<template>
  <div
    class="container flex items-center justify-center w-full gap-3 px-5 mx-auto my-3 lg:w-1/2"
  >
    <nuxt-img
      src="images/tru-logo.png"
      class="w-full max-w-[100px] sm:max-w-full"
    />
    <nuxt-img src="images/benefits/plus.png" class="object-contain w-6 md:w-10" />
    <nuxt-img
      src="images/prenatal-logo.png"
      class="w-full max-w-[100px] sm:max-w-full"
    />
  </div>
</template>
